
























import {
  defineComponent, PropType, toRef, useRouter,
} from '@nuxtjs/composition-api';
import { useImage, useUiHelpers } from '~/composables';
import type { CategoryTree } from '~/modules/GraphQL/types';
import ImageWrapper from '~/components/image/ImageWrapper.vue';
import { getCategoryImage } from '~/helpers/getCategoryImage';

export default defineComponent({
  name: 'CategoryTile',
  components: { ImageWrapper },
  props: {
    category: {
      type: Object as PropType<CategoryTree>,
      required: true,
    },
  },
  setup(props) {
    const category = toRef(props, 'category');

    const router = useRouter();
    const { getCatLink } = useUiHelpers();
    const { getMagentoImage } = useImage();

    const pushCategory = () => {
      router.push(getCatLink(category.value));
    };
    return {
      pushCategory,
      getMagentoImage,
      getCategoryImage,
    };
  },
});
